import uuid from 'utils/uuid';

/**
 * Create the Parabo photo.
 * Default values are filled in if some aren't defined.
 * @param {string} url
 * @param {object} [opts]
 * @param {number} [opts.alive]
 * @param {number} [opts.height]
 * @param {string} [opts.key]
 * @param {Array<string>} [opts.tags]
 * @param {string} [opts.type] mimeType e.g. "image/jpeg" (optional)
 * @param {number} [opts.width]
 * @returns {object}
 */
const createPhoto = (url, { alive = 1, height, key = uuid(), tags = [], type, width } = {}) => {
  return { alive, height, key, tags, type, url, width };
};

export default createPhoto;
